module.exports = __webpack_public_path__ + "static/img/studiesOne.b994538.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/studiesOne.png
// module id = gTcZ
// module chunks = 1